import { MessageBox } from 'element-ui'

export function is_wechat() {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) + '' === 'micromessenger') {
    return true
  } else {
    return false
  }
}
// 对象属性逐个赋值
export function objectAssign(arrA, arrB) {
  Object.keys(arrA).forEach(key => { arrA[key] = arrB[key] || arrA[key] })
}

export function is_mobile() {
  if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
    return true
  }
  return false
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  if (!url) {
    url = window.location.href
  }
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  try {
    const para = JSON.parse(
      '{"' +
      search
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
    )
    if (para && para.re && !para.reurl) {
      para.reurl = para.re
    }
    if (para && para.reurl && !para.re) {
      para.re = para.reurl
    }
    return para
  } catch (e) {
    return {}
  }
}

export function formatDate(date, fmt) {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) { if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  return fmt
}

// 计算除去上下header footer后剩余高度
export function getViewHeight() {
  const f = document.getElementById('footer')
  const fh = f.clientHeight || f.offsetHeight
  const h = document.getElementById('header')
  const hh = h.clientHeight || h.offsetHeight
  return document.documentElement.clientHeight - fh - hh - 18 // 后面减去的10是误差
}

export function showRejectDialog(action) {
  MessageBox({
    title: '提示',
    message: `您的阅读卡已到期，不能使用${action}功能，只能浏览书本`,
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: '去续卡',
    cancelButtonText: '继续阅读'
  }).then(action => {

  }).catch(() => {
    console.log('取消')
  })
}



// WEBPACK FOOTER //
// ./src/utils/index.js